import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { getBoundingBox } from '@/pages/AdvancedEditor/utils/getBoundingBox';
import { ElementsArray, ElementType, GroupElementType } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

const alignMiddle = (element: ElementType, centerY: number) => {
    const box = getBoundingBox(element);
    const offsetY = (box.maxY - box.minY) / 2 - (element.y - box.minY);
    element.set({ y: centerY - offsetY });
};

export function alignElementsMiddle(store: StoreType, elements: ElementsArray) {
    const centerY =
        elements.length > 1
            ? (Math.max(...elements.map(getBoundingBox).map(box => box.maxY)) +
                  Math.min(...elements.map(getBoundingBox).map(box => box.minY))) /
              2
            : store.height / 2;

    elements.forEach(element => {
        alignMiddle(element, centerY);

        if (element.type === polotnoTypes.Group) {
            (element as GroupElementType).children.forEach((child: ElementType) => {
                alignMiddle(child, centerY);
            });
        }
    });
}
